import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";

const AuthService = {};

AuthService.login = function (data) {
  // const params = new URLSearchParams();
  // for (const key in data) {
  //   params.append(key, data[key]);
  // }

  return fetch({
    url: ApiConstant.LOGIN,
    method: "post",
    data: data,
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
  });
};

AuthService.Encryption = function () {

  return fetch({
    url: ApiConstant.ENCRYPTION,
    method: "get"
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};

AuthService.logout = function () {
  return fetch({
    url: ApiConstant.LOGOUT,
    method: "post",
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: "/auth/loginInOAuth",
    method: "post",
  });
};

export default AuthService;
